var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightModeImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 65,
    viewBox: "0 0 96 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.5 7)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 65,
    fill: "#f7fafd",
    rx: 8,
    transform: "translate(2.5 -7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d3d5f",
    d: "M8 0h80a8 8 0 0 1 8 8v1H0V8a8 8 0 0 1 8-8z",
    transform: "translate(2.5 -7)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#3c4043",
    fontFamily: "OpenSans, Open Sans",
    fontSize: "22px",
    transform: "translate(23.5 39)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -13.079,
    y: 0
  }, "Aa")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "rgba(0,0,0,0.1)",
    transform: "translate(44.5 9)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 42,
    stroke: "none",
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 41,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 4.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#9e90ed",
    d: "M2.5 0A2.5 2.5 0 0 1 5 2.5V25H0V2.5A2.5 2.5 0 0 1 2.5 0z",
    transform: "translate(-92.879 -292.729) translate(155.379 317.73)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1473e6",
    d: "M2.5 0A2.5 2.5 0 0 1 5 2.5V20H0V2.5A2.5 2.5 0 0 1 2.5 0z",
    transform: "translate(-92.879 -292.729) translate(147.379 322.73)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00c6db",
    d: "M2.5 0A2.5 2.5 0 0 1 5 2.5V30H0V2.5A2.5 2.5 0 0 1 2.5 0z",
    transform: "translate(-92.879 -292.729) translate(163.379 312.73)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff81c0",
    d: "M2 0a2 2 0 0 1 2 2v18H0V2a2 2 0 0 1 2-2z",
    transform: "translate(-92.879 -292.729) translate(172.379 322.73)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightModeImage);
export default __webpack_public_path__ + "static/media/light-mode-image.7195ad41e95095b6376cbebf7bfeb92d.svg";
export { ForwardRef as ReactComponent };